<template>
  <el-checkbox @change="onChange" class="mb-2 pr-2" v-model="status.state">{{ label }}</el-checkbox>
  <div v-if="status.state" class="ml-6">
    <div>
      <el-radio @change="onChange" v-model="status.value" label="true">True</el-radio>
    </div>
    <div>
      <el-radio @change="onChange" v-model="status.value" label="false">False</el-radio>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'checkbox-with-radio',
  data: function () {
    return {
      status: {
        state: false,
        value: 'true',
      },
    };
  },
  props: {
    label: String,
    indentifier: String,
  },
  emits: ['changed'],
  methods: {
    onChange: function () {
      this.$emit('changed', {
        status: this.status,
        label: this.label,
        indentifier: this.indentifier,
      });
    },
    reset: function () {
      this.status = {
        state: false,
        value: 'true',
      };
    },
  },
});
</script>
